import { CLOUDINARY_DY_REMOTE_FOLDER } from '../../../constants/cloudinary';

export function dyImageSrcToCloudinaryImageSrc(src: string): string {
  return src.replace('https://cdn-eu.dynamicyield.com/api', CLOUDINARY_DY_REMOTE_FOLDER);
}
